import gql from "graphql-tag";

export const slots = gql`
  query {
    slots {
      uuid
      x
      y
      z
      polygons {
        uuid
      }
    }
  }
`;

export const getCoilStock = gql`
  query {
    getMaterialStock {
      coil {
        uuid
        codigo
        gruaWeightBruto
        gruaWeightNeto
        numMaterial
        qualityDefect
        sapThickness
        sapWeightBruto
        sapWeightNeto
        sapWidth
        supplierBatch
        tipoTransporte
        tipoZ
        diameter
        composition
        deleted
        lastLabeled
      }
      deposit {
        uuid
        position {
          x
          y
          z
        }
        logicalPosition {
          level
          row
        }
        positionPLC {
          x
          y
          z
        }
        restTo {
          left
          right
        }
        slot
        restFromRight
        restFromLeft
        surfaces {
          uuid
          zones {
            name
            uuid
          }
        }
      }
      diameter
    }
  }
`;

export const getCoilStockByDeposit = gql`
  query GetCoilStockByDeposit($uuid: String) {
    getCoilStockByDeposit(uuid: $uuid) {
      coil {
        uuid
        codigo
        typeName
        gruaWeightBruto
        gruaWeightNeto
        isCoilPeeled
        numMaterial
        qualityDefect
        sapThickness
        sapWeightBruto
        sapWeightNeto
        sapWidth
        supplierBatch
        tipoTransporte
        tipoZ
        diameter
        composition
        deleted
        lastLabeled
        codOrigin
        isQualityChecked
        qualityDefects
        isSapPreordered
        isSapRegistered
      }
      crane
      deposit {
        uuid
        slot
        restFromLeft
        restFromRight
        position {
          x
          y
          z
        }
        positionPLC {
          x
          y
          z
        }
        logicalPosition {
          level
          row
        }
        surfaces {
          uuid
          zones {
            uuid
            name
          }
        }
        restTo {
          left
          right
        }
      }
      diameter
    }
  }
`;

export const zoneCoils = gql`
  query ZoneCoils {
    zoneCoils {
      description
      labels
      name
      uuid
      polygons {
        uuid
        pointsConnection {
          edges {
            uuid
            n
            node {
              uuid
              x
              y
            }
          }
        }
        slots {
          uuid
          x
          y
          z
        }
      }
    }
  }
`;

export const zoneDies = gql`
  query ZoneDies {
    zoneDies {
      description
      labels
      name
      uuid
      polygons {
        uuid
        pointsConnection {
          edges {
            uuid
            n
            node {
              uuid
              x
              y
            }
          }
        }
        slots {
          uuid
          x
          y
          z
        }
      }
    }
  }
`;

export const zoneSingulars = gql`
  query ZoneSingulars {
    zoneSingulars {
      description
      labels
      name
      uuid
      polygons {
        uuid
        pointsConnection {
          edges {
            uuid
            n
            node {
              uuid
              x
              y
            }
          }
        }
        slots {
          uuid
          x
          y
          z
        }
      }
    }
  }
`;

export const debuggerLiftPosition = gql`
  mutation Mutation($x: Float, $y: Float, $z: Float, $crane: String) {
    debugLiftCoil(x: $x, y: $y, z: $z, crane: $crane)
  }
`;

export const debuggerDepositPosition = gql`
  mutation Mutation($x: Float, $y: Float, $z: Float, $crane: String) {
    debugDepositCoil(x: $x, y: $y, z: $z, crane: $crane)
  }
`;

export const timeSubscription = gql`
  subscription {
    seconds {
      time
    }
  }
`;

export const liftws = gql`
  subscription {
    lift {
      content {
        deposit
        material
        crane
        step {
          uuid
          time
          position {
            x
            y
            z
          }
        }
      }
    }
  }
`;

export const depositws = gql`
  subscription {
    deposit {
      content {
        crane
        lift
        material
        step {
          time
          uuid
          position {
            x
            y
            z
          }
        }
      }
    }
  }
`;

export const getCranes = gql`
  query GetCranes {
    getCranes {
      codigo
      name
      uuid
      to {
        x
        y
        z
      }
      from {
        x
        y
        z
      }
    }
  }
`;

export const getMaterialStock = gql`
  query GetMaterialStock {
    getMaterialStock {
      diameter
      crane
      coil {
        uuid
        codigo
        typeName
        gruaWeightBruto
        gruaWeightNeto
        isCoilPeeled
        numMaterial
        qualityDefect
        sapThickness
        sapWeightBruto
        sapWeightNeto
        sapWidth
        supplierBatch
        tipoTransporte
        tipoZ
        diameter
        composition
        deleted
        lastLabeled
        codOrigin
        isQualityChecked
        qualityDefects
        isSapPreordered
        isSapRegistered
      }
      die {
        uuid
        codigo
        dieHeight
        dieWidth
        sapLength
        sapWidth
        tipoZ
      }
      lift {
        uuid
        position {
          x
          y
          z
        }
      }
      deposit {
        uuid
        slot
        restFromLeft
        restFromRight
        position {
          x
          y
          z
        }
        positionPLC {
          x
          y
          z
        }
        logicalPosition {
          level
          row
        }
        surfaces {
          uuid
          zones {
            uuid
            name
          }
        }
        restTo {
          left
          right
        }
      }
    }
  }
`;
